import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'light' | 'dark';

/** Themes de la barre haute dont les fonds sont sombres : PrimeNG doit passer en mode sombre. */
export const THEMES_SOMBRES: ReadonlySet<string> = new Set(['midnight', 'warm', 'ocean']);

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    currentTheme = signal<Theme>('light');

    constructor() {
        // Load saved theme or default to light for Retail vibe
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'light' || savedTheme === 'dark') {
            this.currentTheme.set(savedTheme);
        } else {
            // Default to light for retail focus as requested
            this.currentTheme.set('light');
        }

        // Effect to apply class to document body
        effect(() => {
            const theme = this.currentTheme();
            localStorage.setItem('theme', theme);

            const html = document.documentElement;
            if (theme === 'dark') {
                html.classList.add('dark');
            } else {
                html.classList.remove('dark');
            }
        });
    }

    toggleTheme() {
        this.currentTheme.update(current => current === 'light' ? 'dark' : 'light');
    }

    setTheme(theme: Theme) {
        this.currentTheme.set(theme);
    }
}
